import { useProposalContext } from '@modules/proposal/ProposalBuilderPage';
import { CourseBuilder } from '../Blocks/types';
import { useImperativeHandle, useEffect, useMemo, useCallback, useState, useRef } from 'react';
import { openBlockSettingsOverlay } from '../Blocks/Common/BlockBaseConfig';
import { useLazyEffect } from '@core/utils/react';
import { FormGroup, useFormConfig } from '@core/utils/form';
import { useNonNilObservable } from '@core/utils/hooks/rxjs';
import { useCourseBuilderBlockContext, useCourseBuilderContext } from '../CourseBuilderPage';
import { of, Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

export interface CourseFormHook<P = any> {
  onSubmit: (data: any) => Observable<any>;
}

export interface CourseFormReturn {
  submit(): Observable<boolean>;
}

export function useCourseForm<P extends any>(id: string, form: FormGroup<any>, props: CourseFormHook<P>) {
  const proposal = useCourseBuilderContext();

  const submit = useCallback(() => {
    const obs$ = new Subject<boolean>();
    form.setConfig({
      handleSubmit: (data: any) => {
        return props.onSubmit(data).pipe(
          tap(result => {
            if (result) {
              obs$.next(true);
              obs$.complete();
            }
          }),
        );
      },
    });
    setTimeout(() => {
      obs$.next(false);
      form.submit();
    }, 500);
    return obs$;
  }, [form, props]);

  useEffect(() => {
    if (proposal && proposal.registerForms) {
      proposal.registerForms(id, submit);
    }
  }, [proposal, id, submit]);

  return { submit };
}
